<template>
  <div :class="width">
    <date-picker outlined
      :label="label"
      single-line
      class="input input-data-nascimento"
      v-model="value"
      :validator="validator"
      :class="width"
      :error-messages="errors.first(field)"
      :name="field" />
  </div>
</template>

<script>
import DatePicker from '@/components/dynamic/DatePicker.vue'

export default {
  inject: ['$validator'],
  components: {
    DatePicker
  },
  props: {
    label: String,
    field: String,
    config: Object,
    validator: Object,
    width: {
      type: String,
      default: 'col-100'
    },
    extra_data: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    componentValue() {
      return true
    }
  }
}
</script>
<style lang="css" scoped></style>
